// src/hooks/useAISandboxData.ts
import { useEffect, useState } from "react";
import { fetchAISandboxData, type AISandboxData } from "@/app/services/simulation/ai-sandbox-service";

export function useAISandboxData(brand: string) {
  const [data, setData] = useState<AISandboxData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function run() {
      try {
        setLoading(true);
        setError(null);

        const res = await fetchAISandboxData({ brand });
        if (cancelled) return;

        setData(res);
      } catch (e: any) {
        if (cancelled) return;

        // preserve server error text when possible
        const msg =
          typeof e?.message === "string" && e.message
            ? e.message
            : "Failed to load sandbox data";
        setError(e instanceof Error ? e : new Error(msg));
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    const b = (brand || "").trim();
    if (!b) {
      setData(null);
      setLoading(false);
      return;
    }

    run();
    return () => {
      cancelled = true;
    };
  }, [brand]);

  return { data, setData, loading, error };
}
